import styled from '@emotion/styled';
import { forwardRef, ReactNode } from 'react';
import { Alert, AlertColor, AlertTitle } from '@mui/material';
import { SnackbarContent, useSnackbar, CustomContentProps } from 'notistack';
import { DismissButton } from '../buttons';

interface Props extends CustomContentProps {
  description: ReactNode;
}

const StyledSnackbarContent = styled(SnackbarContent)`
  width: 340px;
  justify-content: flex-end;
`;

const StyledAlert = styled(Alert)`
  align-items: center;
`;

const severityVariantMap: Record<CustomContentProps['variant'], AlertColor> = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
  default: 'info',
};

export const Snackbar = forwardRef<HTMLDivElement, Props>(
  ({ id, message, variant, description }, ref) => {
    const { closeSnackbar } = useSnackbar();
    const handleCloseSnackbar = () => closeSnackbar(id);

    return (
      <StyledSnackbarContent ref={ref}>
        <StyledAlert
          severity={severityVariantMap[variant]}
          aria-live='polite'
          action={<DismissButton onClose={handleCloseSnackbar} />}
        >
          <AlertTitle>{message}</AlertTitle>
          {description && description}
        </StyledAlert>
      </StyledSnackbarContent>
    );
  },
);
